
<img :src="`/images/flags/${iso}.png`" :class="flagClass" :title="title" />
